module.exports = __webpack_public_path__ + "img/menu_parc.68c13155.svg";